export enum HomeFlyoutTypes {
    search,
    views,
    layers,
    weather,
    filters
}
